import { useCallback, useEffect, useRef, useState } from "react";

/**
 * The little pop the heart makes when a wish is ADDED.
 *
 * Driven by transient state rather than by the `.active` class, and that is
 * the whole reason this exists: a CSS animation attached to `.active` also
 * fires whenever an already-wished card mounts, so scrolling a grid would
 * set every saved heart popping. This fires on the transition into wished,
 * and never on removal — taking something off the list is not a moment to
 * celebrate.
 *
 * The timeout is cleared on unmount, so a card scrolled out of a virtualised
 * list mid-animation cannot set state on a gone component.
 */
const POP_MS = 320;

export const useWishPop = (duration = POP_MS) => {
  const [popping, setPopping] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const pop = useCallback(() => {
    clearTimeout(timer.current);
    setPopping(true);
    timer.current = setTimeout(() => setPopping(false), duration);
  }, [duration]);

  return [popping, pop];
};

export default useWishPop;
